export default __webpack_public_path__ + "static/media/logo.41c610f4.svg";